var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.type == "question"
      ? _c("span", { staticClass: "symbol-label" }, [
          _c("span", { staticClass: "svg-icon svg-icon-xl svg-icon-primary" }, [
            _c(
              "span",
              { staticClass: "svg-icon svg-icon-primary svg-icon-2x" },
              [
                _c(
                  "svg",
                  {
                    attrs: {
                      xmlns: "http://www.w3.org/2000/svg",
                      "xmlns:xlink": "http://www.w3.org/1999/xlink",
                      width: "24px",
                      height: "24px",
                      viewBox: "0 0 24 24",
                      version: "1.1"
                    }
                  },
                  [
                    _c(
                      "g",
                      {
                        attrs: {
                          stroke: "none",
                          "stroke-width": "1",
                          fill: "none",
                          "fill-rule": "evenodd"
                        }
                      },
                      [
                        _c("rect", {
                          attrs: { x: "0", y: "0", width: "24", height: "24" }
                        }),
                        _vm._v(" "),
                        _c("circle", {
                          attrs: {
                            fill: "#000000",
                            opacity: "0.3",
                            cx: "12",
                            cy: "12",
                            r: "10"
                          }
                        }),
                        _vm._v(" "),
                        _c("path", {
                          attrs: {
                            d:
                              "M12,16 C12.5522847,16 13,16.4477153 13,17 C13,17.5522847 12.5522847,18 12,18 C11.4477153,18 11,17.5522847 11,17 C11,16.4477153 11.4477153,16 12,16 Z M10.591,14.868 L10.591,13.209 L11.851,13.209 C13.447,13.209 14.602,11.991 14.602,10.395 C14.602,8.799 13.447,7.581 11.851,7.581 C10.234,7.581 9.121,8.799 9.121,10.395 L7.336,10.395 C7.336,7.875 9.31,5.922 11.851,5.922 C14.392,5.922 16.387,7.875 16.387,10.395 C16.387,12.915 14.392,14.868 11.851,14.868 L10.591,14.868 Z",
                            fill: "#000000"
                          }
                        })
                      ]
                    )
                  ]
                )
              ]
            )
          ])
        ])
      : _vm.type == "euro"
      ? _c("span", { staticClass: "symbol-label" }, [
          _c("span", { staticClass: "svg-icon svg-icon-xl svg-icon-primary" }, [
            _c(
              "span",
              { staticClass: "svg-icon svg-icon-primary svg-icon-2x" },
              [
                _c(
                  "svg",
                  {
                    attrs: {
                      xmlns: "http://www.w3.org/2000/svg",
                      "xmlns:xlink": "http://www.w3.org/1999/xlink",
                      width: "24px",
                      height: "24px",
                      viewBox: "0 0 24 24",
                      version: "1.1"
                    }
                  },
                  [
                    _c(
                      "g",
                      {
                        attrs: {
                          stroke: "none",
                          "stroke-width": "1",
                          fill: "none",
                          "fill-rule": "evenodd"
                        }
                      },
                      [
                        _c("rect", {
                          attrs: { x: "0", y: "0", width: "24", height: "24" }
                        }),
                        _vm._v(" "),
                        _c("path", {
                          attrs: {
                            d:
                              "M4.3618034,10.2763932 L4.8618034,9.2763932 C4.94649941,9.10700119 5.11963097,9 5.30901699,9 L15.190983,9 C15.4671254,9 15.690983,9.22385763 15.690983,9.5 C15.690983,9.57762255 15.6729105,9.65417908 15.6381966,9.7236068 L15.1381966,10.7236068 C15.0535006,10.8929988 14.880369,11 14.690983,11 L4.80901699,11 C4.53287462,11 4.30901699,10.7761424 4.30901699,10.5 C4.30901699,10.4223775 4.32708954,10.3458209 4.3618034,10.2763932 Z M14.6381966,13.7236068 L14.1381966,14.7236068 C14.0535006,14.8929988 13.880369,15 13.690983,15 L4.80901699,15 C4.53287462,15 4.30901699,14.7761424 4.30901699,14.5 C4.30901699,14.4223775 4.32708954,14.3458209 4.3618034,14.2763932 L4.8618034,13.2763932 C4.94649941,13.1070012 5.11963097,13 5.30901699,13 L14.190983,13 C14.4671254,13 14.690983,13.2238576 14.690983,13.5 C14.690983,13.5776225 14.6729105,13.6541791 14.6381966,13.7236068 Z",
                            fill: "#000000",
                            opacity: "0.3"
                          }
                        }),
                        _vm._v(" "),
                        _c("path", {
                          attrs: {
                            d:
                              "M17.369,7.618 C16.976998,7.08599734 16.4660031,6.69750122 15.836,6.4525 C15.2059968,6.20749878 14.590003,6.085 13.988,6.085 C13.2179962,6.085 12.5180032,6.2249986 11.888,6.505 C11.2579969,6.7850014 10.7155023,7.16999755 10.2605,7.66 C9.80549773,8.15000245 9.45550123,8.72399671 9.2105,9.382 C8.96549878,10.0400033 8.843,10.7539961 8.843,11.524 C8.843,12.3360041 8.96199881,13.0779966 9.2,13.75 C9.43800119,14.4220034 9.7774978,14.9994976 10.2185,15.4825 C10.6595022,15.9655024 11.1879969,16.3399987 11.804,16.606 C12.4200031,16.8720013 13.1129962,17.005 13.883,17.005 C14.681004,17.005 15.3879969,16.8475016 16.004,16.5325 C16.6200031,16.2174984 17.1169981,15.8010026 17.495,15.283 L19.616,16.774 C18.9579967,17.6000041 18.1530048,18.2404977 17.201,18.6955 C16.2489952,19.1505023 15.1360064,19.378 13.862,19.378 C12.6999942,19.378 11.6325049,19.1855019 10.6595,18.8005 C9.68649514,18.4154981 8.8500035,17.8765035 8.15,17.1835 C7.4499965,16.4904965 6.90400196,15.6645048 6.512,14.7055 C6.11999804,13.7464952 5.924,12.6860058 5.924,11.524 C5.924,10.333994 6.13049794,9.25950479 6.5435,8.3005 C6.95650207,7.34149521 7.5234964,6.52600336 8.2445,5.854 C8.96550361,5.18199664 9.8159951,4.66400182 10.796,4.3 C11.7760049,3.93599818 12.8399943,3.754 13.988,3.754 C14.4640024,3.754 14.9609974,3.79949954 15.479,3.8905 C15.9970026,3.98150045 16.4939976,4.12149906 16.97,4.3105 C17.4460024,4.49950095 17.8939979,4.7339986 18.314,5.014 C18.7340021,5.2940014 19.0909985,5.62999804 19.385,6.022 L17.369,7.618 Z",
                            fill: "#000000"
                          }
                        })
                      ]
                    )
                  ]
                )
              ]
            )
          ])
        ])
      : _vm.type == "time"
      ? _c("span", { staticClass: "symbol-label" }, [
          _c("span", { staticClass: "svg-icon svg-icon-xl svg-icon-primary" }, [
            _c(
              "span",
              { staticClass: "svg-icon svg-icon-primary svg-icon-2x" },
              [
                _c(
                  "svg",
                  {
                    attrs: {
                      xmlns: "http://www.w3.org/2000/svg",
                      "xmlns:xlink": "http://www.w3.org/1999/xlink",
                      width: "24px",
                      height: "24px",
                      viewBox: "0 0 24 24",
                      version: "1.1"
                    }
                  },
                  [
                    _c(
                      "g",
                      {
                        attrs: {
                          stroke: "none",
                          "stroke-width": "1",
                          fill: "none",
                          "fill-rule": "evenodd"
                        }
                      },
                      [
                        _c("rect", {
                          attrs: { x: "0", y: "0", width: "24", height: "24" }
                        }),
                        _vm._v(" "),
                        _c("path", {
                          attrs: {
                            d:
                              "M7.14319965,19.3575259 C7.67122143,19.7615175 8.25104409,20.1012165 8.87097532,20.3649307 L7.89205065,22.0604779 C7.61590828,22.5387706 7.00431787,22.7026457 6.52602525,22.4265033 C6.04773263,22.150361 5.88385747,21.5387706 6.15999985,21.0604779 L7.14319965,19.3575259 Z M15.1367085,20.3616573 C15.756345,20.0972995 16.3358198,19.7569961 16.8634386,19.3524415 L17.8320512,21.0301278 C18.1081936,21.5084204 17.9443184,22.1200108 17.4660258,22.3961532 C16.9877332,22.6722956 16.3761428,22.5084204 16.1000004,22.0301278 L15.1367085,20.3616573 Z",
                            fill: "#000000"
                          }
                        }),
                        _vm._v(" "),
                        _c("path", {
                          attrs: {
                            d:
                              "M12,21 C7.581722,21 4,17.418278 4,13 C4,8.581722 7.581722,5 12,5 C16.418278,5 20,8.581722 20,13 C20,17.418278 16.418278,21 12,21 Z M19.068812,3.25407593 L20.8181344,5.00339833 C21.4039208,5.58918477 21.4039208,6.53893224 20.8181344,7.12471868 C20.2323479,7.71050512 19.2826005,7.71050512 18.696814,7.12471868 L16.9474916,5.37539627 C16.3617052,4.78960984 16.3617052,3.83986237 16.9474916,3.25407593 C17.5332781,2.66828949 18.4830255,2.66828949 19.068812,3.25407593 Z M5.29862906,2.88207799 C5.8844155,2.29629155 6.83416297,2.29629155 7.41994941,2.88207799 C8.00573585,3.46786443 8.00573585,4.4176119 7.41994941,5.00339833 L5.29862906,7.12471868 C4.71284263,7.71050512 3.76309516,7.71050512 3.17730872,7.12471868 C2.59152228,6.53893224 2.59152228,5.58918477 3.17730872,5.00339833 L5.29862906,2.88207799 Z",
                            fill: "#000000",
                            opacity: "0.3"
                          }
                        }),
                        _vm._v(" "),
                        _c("path", {
                          attrs: {
                            d:
                              "M11.9630156,7.5 L12.0475062,7.5 C12.3043819,7.5 12.5194647,7.69464724 12.5450248,7.95024814 L13,12.5 L16.2480695,14.3560397 C16.403857,14.4450611 16.5,14.6107328 16.5,14.7901613 L16.5,15 C16.5,15.2109164 16.3290185,15.3818979 16.1181021,15.3818979 C16.0841582,15.3818979 16.0503659,15.3773725 16.0176181,15.3684413 L11.3986612,14.1087258 C11.1672824,14.0456225 11.0132986,13.8271186 11.0316926,13.5879956 L11.4644883,7.96165175 C11.4845267,7.70115317 11.7017474,7.5 11.9630156,7.5 Z",
                            fill: "#000000"
                          }
                        })
                      ]
                    )
                  ]
                )
              ]
            )
          ])
        ])
      : _vm.type == "check"
      ? _c("span", { staticClass: "symbol-label" }, [
          _c("span", { staticClass: "svg-icon svg-icon-xl svg-icon-primary" }, [
            _c(
              "span",
              { staticClass: "svg-icon svg-icon-primary svg-icon-2x" },
              [
                _c(
                  "svg",
                  {
                    attrs: {
                      xmlns: "http://www.w3.org/2000/svg",
                      "xmlns:xlink": "http://www.w3.org/1999/xlink",
                      width: "24px",
                      height: "24px",
                      viewBox: "0 0 24 24",
                      version: "1.1"
                    }
                  },
                  [
                    _c(
                      "g",
                      {
                        attrs: {
                          stroke: "none",
                          "stroke-width": "1",
                          fill: "none",
                          "fill-rule": "evenodd"
                        }
                      },
                      [
                        _c("rect", {
                          attrs: { x: "0", y: "0", width: "24", height: "24" }
                        }),
                        _vm._v(" "),
                        _c("circle", {
                          attrs: {
                            fill: "#000000",
                            opacity: "0.3",
                            cx: "12",
                            cy: "12",
                            r: "10"
                          }
                        }),
                        _vm._v(" "),
                        _c("path", {
                          attrs: {
                            d:
                              "M16.7689447,7.81768175 C17.1457787,7.41393107 17.7785676,7.39211077 18.1823183,7.76894473 C18.5860689,8.1457787 18.6078892,8.77856757 18.2310553,9.18231825 L11.2310553,16.6823183 C10.8654446,17.0740439 10.2560456,17.107974 9.84920863,16.7592566 L6.34920863,13.7592566 C5.92988278,13.3998345 5.88132125,12.7685345 6.2407434,12.3492086 C6.60016555,11.9298828 7.23146553,11.8813212 7.65079137,12.2407434 L10.4229928,14.616916 L16.7689447,7.81768175 Z",
                            fill: "#000000",
                            "fill-rule": "nonzero"
                          }
                        })
                      ]
                    )
                  ]
                )
              ]
            )
          ])
        ])
      : _vm.type == "user"
      ? _c("span", { staticClass: "symbol-label" }, [
          _c("span", { staticClass: "svg-icon svg-icon-primary svg-icon-2x" }, [
            _c(
              "svg",
              {
                attrs: {
                  xmlns: "http://www.w3.org/2000/svg",
                  "xmlns:xlink": "http://www.w3.org/1999/xlink",
                  width: "24px",
                  height: "24px",
                  viewBox: "0 0 24 24",
                  version: "1.1"
                }
              },
              [
                _c(
                  "g",
                  {
                    attrs: {
                      stroke: "none",
                      "stroke-width": "1",
                      fill: "none",
                      "fill-rule": "evenodd"
                    }
                  },
                  [
                    _c("polygon", { attrs: { points: "0 0 24 0 24 24 0 24" } }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        d:
                          "M12,11 C9.790861,11 8,9.209139 8,7 C8,4.790861 9.790861,3 12,3 C14.209139,3 16,4.790861 16,7 C16,9.209139 14.209139,11 12,11 Z",
                        fill: "#000000",
                        "fill-rule": "nonzero",
                        opacity: "0.3"
                      }
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        d:
                          "M3.00065168,20.1992055 C3.38825852,15.4265159 7.26191235,13 11.9833413,13 C16.7712164,13 20.7048837,15.2931929 20.9979143,20.2 C21.0095879,20.3954741 20.9979143,21 20.2466999,21 C16.541124,21 11.0347247,21 3.72750223,21 C3.47671215,21 2.97953825,20.45918 3.00065168,20.1992055 Z",
                        fill: "#000000",
                        "fill-rule": "nonzero"
                      }
                    })
                  ]
                )
              ]
            )
          ])
        ])
      : _vm.type == "mail"
      ? _c("span", { staticClass: "symbol-label" }, [
          _c("span", { staticClass: "svg-icon svg-icon-primary svg-icon-2x" }, [
            _c(
              "svg",
              {
                attrs: {
                  xmlns: "http://www.w3.org/2000/svg",
                  "xmlns:xlink": "http://www.w3.org/1999/xlink",
                  width: "24px",
                  height: "24px",
                  viewBox: "0 0 24 24",
                  version: "1.1"
                }
              },
              [
                _c(
                  "g",
                  {
                    attrs: {
                      stroke: "none",
                      "stroke-width": "1",
                      fill: "none",
                      "fill-rule": "evenodd"
                    }
                  },
                  [
                    _c("rect", {
                      attrs: { x: "0", y: "0", width: "24", height: "24" }
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        d:
                          "M5,6 L19,6 C20.1045695,6 21,6.8954305 21,8 L21,17 C21,18.1045695 20.1045695,19 19,19 L5,19 C3.8954305,19 3,18.1045695 3,17 L3,8 C3,6.8954305 3.8954305,6 5,6 Z M18.1444251,7.83964668 L12,11.1481833 L5.85557487,7.83964668 C5.4908718,7.6432681 5.03602525,7.77972206 4.83964668,8.14442513 C4.6432681,8.5091282 4.77972206,8.96397475 5.14442513,9.16035332 L11.6444251,12.6603533 C11.8664074,12.7798822 12.1335926,12.7798822 12.3555749,12.6603533 L18.8555749,9.16035332 C19.2202779,8.96397475 19.3567319,8.5091282 19.1603533,8.14442513 C18.9639747,7.77972206 18.5091282,7.6432681 18.1444251,7.83964668 Z",
                        fill: "#000000"
                      }
                    })
                  ]
                )
              ]
            )
          ])
        ])
      : _vm.type == "phone"
      ? _c("span", { staticClass: "symbol-label" }, [
          _c("span", { staticClass: "svg-icon svg-icon-primary svg-icon-2x" }, [
            _c(
              "svg",
              {
                attrs: {
                  xmlns: "http://www.w3.org/2000/svg",
                  "xmlns:xlink": "http://www.w3.org/1999/xlink",
                  width: "24px",
                  height: "24px",
                  viewBox: "0 0 24 24",
                  version: "1.1"
                }
              },
              [
                _c(
                  "g",
                  {
                    attrs: {
                      stroke: "none",
                      "stroke-width": "1",
                      fill: "none",
                      "fill-rule": "evenodd"
                    }
                  },
                  [
                    _c("rect", {
                      attrs: { x: "0", y: "0", width: "24", height: "24" }
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        d:
                          "M7.13888889,4 L7.13888889,19 L16.8611111,19 L16.8611111,4 L7.13888889,4 Z M7.83333333,1 L16.1666667,1 C17.5729473,1 18.25,1.98121694 18.25,3.5 L18.25,20.5 C18.25,22.0187831 17.5729473,23 16.1666667,23 L7.83333333,23 C6.42705272,23 5.75,22.0187831 5.75,20.5 L5.75,3.5 C5.75,1.98121694 6.42705272,1 7.83333333,1 Z",
                        fill: "#000000",
                        "fill-rule": "nonzero"
                      }
                    }),
                    _vm._v(" "),
                    _c("polygon", {
                      attrs: {
                        fill: "#000000",
                        opacity: "0.3",
                        points: "7 4 7 19 17 19 17 4"
                      }
                    }),
                    _vm._v(" "),
                    _c("circle", {
                      attrs: { fill: "#000000", cx: "12", cy: "21", r: "1" }
                    })
                  ]
                )
              ]
            )
          ])
        ])
      : _vm.type == "intervall"
      ? _c("span", { staticClass: "symbol-label" }, [
          _c("span", { staticClass: "svg-icon svg-icon-primary svg-icon-2x" }, [
            _c(
              "svg",
              {
                attrs: {
                  xmlns: "http://www.w3.org/2000/svg",
                  "xmlns:xlink": "http://www.w3.org/1999/xlink",
                  width: "24px",
                  height: "24px",
                  viewBox: "0 0 24 24",
                  version: "1.1"
                }
              },
              [
                _c(
                  "g",
                  {
                    attrs: {
                      stroke: "none",
                      "stroke-width": "1",
                      fill: "none",
                      "fill-rule": "evenodd"
                    }
                  },
                  [
                    _c("rect", {
                      attrs: { x: "0", y: "0", width: "24", height: "24" }
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        d:
                          "M12,8 L8,8 C5.790861,8 4,9.790861 4,12 L4,13 C4,14.6568542 5.34314575,16 7,16 L7,18 C4.23857625,18 2,15.7614237 2,13 L2,12 C2,8.6862915 4.6862915,6 8,6 L12,6 L12,4.72799742 C12,4.62015048 12.0348702,4.51519416 12.0994077,4.42878885 C12.264656,4.2075478 12.5779675,4.16215674 12.7992086,4.32740507 L15.656242,6.46136716 C15.6951359,6.49041758 15.7295917,6.52497737 15.7585249,6.56395854 C15.9231063,6.78569617 15.876772,7.09886961 15.6550344,7.263451 L12.798001,9.3840407 C12.7118152,9.44801079 12.607332,9.48254921 12.5,9.48254921 C12.2238576,9.48254921 12,9.25869158 12,8.98254921 L12,8 Z",
                        fill: "#000000"
                      }
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        d:
                          "M12.0583175,16 L16,16 C18.209139,16 20,14.209139 20,12 L20,11 C20,9.34314575 18.6568542,8 17,8 L17,6 C19.7614237,6 22,8.23857625 22,11 L22,12 C22,15.3137085 19.3137085,18 16,18 L12.0583175,18 L12.0583175,18.9825492 C12.0583175,19.2586916 11.8344599,19.4825492 11.5583175,19.4825492 C11.4509855,19.4825492 11.3465023,19.4480108 11.2603165,19.3840407 L8.40328311,17.263451 C8.18154548,17.0988696 8.13521119,16.7856962 8.29979258,16.5639585 C8.32872576,16.5249774 8.36318164,16.4904176 8.40207551,16.4613672 L11.2591089,14.3274051 C11.48035,14.1621567 11.7936615,14.2075478 11.9589099,14.4287888 C12.0234473,14.5151942 12.0583175,14.6201505 12.0583175,14.7279974 L12.0583175,16 Z",
                        fill: "#000000",
                        opacity: "0.3"
                      }
                    })
                  ]
                )
              ]
            )
          ])
        ])
      : _vm.type == "image"
      ? _c("span", { staticClass: "symbol-label" }, [
          _c("span", { staticClass: "svg-icon svg-icon-primary svg-icon-2x" }, [
            _c(
              "svg",
              {
                attrs: {
                  xmlns: "http://www.w3.org/2000/svg",
                  "xmlns:xlink": "http://www.w3.org/1999/xlink",
                  width: "24px",
                  height: "24px",
                  viewBox: "0 0 24 24",
                  version: "1.1"
                }
              },
              [
                _c(
                  "g",
                  {
                    attrs: {
                      stroke: "none",
                      "stroke-width": "1",
                      fill: "none",
                      "fill-rule": "evenodd"
                    }
                  },
                  [
                    _c("rect", {
                      attrs: { x: "0", y: "0", width: "24", height: "24" }
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        d:
                          "M5,7 L19,7 C20.1045695,7 21,7.8954305 21,9 L21,17 C21,18.1045695 20.1045695,19 19,19 L5,19 C3.8954305,19 3,18.1045695 3,17 L3,9 C3,7.8954305 3.8954305,7 5,7 Z M12,17 C14.209139,17 16,15.209139 16,13 C16,10.790861 14.209139,9 12,9 C9.790861,9 8,10.790861 8,13 C8,15.209139 9.790861,17 12,17 Z",
                        fill: "#000000"
                      }
                    }),
                    _vm._v(" "),
                    _c("rect", {
                      attrs: {
                        fill: "#000000",
                        opacity: "0.3",
                        x: "9",
                        y: "4",
                        width: "6",
                        height: "2",
                        rx: "1"
                      }
                    }),
                    _vm._v(" "),
                    _c("circle", {
                      attrs: {
                        fill: "#000000",
                        opacity: "0.3",
                        cx: "12",
                        cy: "13",
                        r: "2"
                      }
                    })
                  ]
                )
              ]
            )
          ])
        ])
      : _vm.type == "stats"
      ? _c("span", { staticClass: "symbol-label" }, [
          _c("span", { staticClass: "svg-icon svg-icon-primary svg-icon-2x" }, [
            _c(
              "svg",
              {
                attrs: {
                  xmlns: "http://www.w3.org/2000/svg",
                  "xmlns:xlink": "http://www.w3.org/1999/xlink",
                  width: "24px",
                  height: "24px",
                  viewBox: "0 0 24 24",
                  version: "1.1"
                }
              },
              [
                _c(
                  "g",
                  {
                    attrs: {
                      stroke: "none",
                      "stroke-width": "1",
                      fill: "none",
                      "fill-rule": "evenodd"
                    }
                  },
                  [
                    _c("rect", {
                      attrs: { x: "0", y: "0", width: "24", height: "24" }
                    }),
                    _vm._v(" "),
                    _c("rect", {
                      attrs: {
                        fill: "#000000",
                        opacity: "0.3",
                        x: "12",
                        y: "4",
                        width: "3",
                        height: "13",
                        rx: "1.5"
                      }
                    }),
                    _vm._v(" "),
                    _c("rect", {
                      attrs: {
                        fill: "#000000",
                        opacity: "0.3",
                        x: "7",
                        y: "9",
                        width: "3",
                        height: "8",
                        rx: "1.5"
                      }
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        d:
                          "M5,19 L20,19 C20.5522847,19 21,19.4477153 21,20 C21,20.5522847 20.5522847,21 20,21 L4,21 C3.44771525,21 3,20.5522847 3,20 L3,4 C3,3.44771525 3.44771525,3 4,3 C4.55228475,3 5,3.44771525 5,4 L5,19 Z",
                        fill: "#000000",
                        "fill-rule": "nonzero"
                      }
                    }),
                    _vm._v(" "),
                    _c("rect", {
                      attrs: {
                        fill: "#000000",
                        opacity: "0.3",
                        x: "17",
                        y: "11",
                        width: "3",
                        height: "6",
                        rx: "1.5"
                      }
                    })
                  ]
                )
              ]
            )
          ])
        ])
      : _vm.type == "effectiveness"
      ? _c("span", { staticClass: "symbol-label" }, [
          _c("span", { staticClass: "svg-icon svg-icon-primary svg-icon-2x" }, [
            _c(
              "svg",
              {
                attrs: {
                  xmlns: "http://www.w3.org/2000/svg",
                  "xmlns:xlink": "http://www.w3.org/1999/xlink",
                  width: "24px",
                  height: "24px",
                  viewBox: "0 0 24 24",
                  version: "1.1"
                }
              },
              [
                _c(
                  "g",
                  {
                    attrs: {
                      stroke: "none",
                      "stroke-width": "1",
                      fill: "none",
                      "fill-rule": "evenodd"
                    }
                  },
                  [
                    _c("rect", {
                      attrs: { x: "0", y: "0", width: "24", height: "24" }
                    }),
                    _vm._v(" "),
                    _c("rect", {
                      attrs: {
                        fill: "#000000",
                        opacity: "0.3",
                        transform:
                          "translate(12.023129, 11.752757) rotate(33.000000) translate(-12.023129, -11.752757) ",
                        x: "11.0231287",
                        y: "7.92751491",
                        width: "2",
                        height: "7.65048405",
                        rx: "1"
                      }
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        d:
                          "M7.5,3 L16.5,3 C18.9852814,3 21,5.01471863 21,7.5 L21,15.5 C21,17.9852814 18.9852814,20 16.5,20 L7.5,20 C5.01471863,20 3,17.9852814 3,15.5 L3,7.5 C3,5.01471863 5.01471863,3 7.5,3 Z M6,7.88235294 L8.57142857,12 L15.4285714,12 L18,7.88235294 C17,5.96078431 15,5 12,5 C9,5 7,5.96078431 6,7.88235294 Z",
                        fill: "#000000"
                      }
                    })
                  ]
                )
              ]
            )
          ])
        ])
      : _vm.type == "service"
      ? _c("span", { staticClass: "symbol-label" }, [
          _c("span", { staticClass: "svg-icon svg-icon-primary svg-icon-2x" }, [
            _c(
              "svg",
              {
                attrs: {
                  xmlns: "http://www.w3.org/2000/svg",
                  "xmlns:xlink": "http://www.w3.org/1999/xlink",
                  width: "24px",
                  height: "24px",
                  viewBox: "0 0 24 24",
                  version: "1.1"
                }
              },
              [
                _c(
                  "g",
                  {
                    attrs: {
                      stroke: "none",
                      "stroke-width": "1",
                      fill: "none",
                      "fill-rule": "evenodd"
                    }
                  },
                  [
                    _c("rect", {
                      attrs: { x: "0", y: "0", width: "24", height: "24" }
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        d:
                          "M8,3 L8,3.5 C8,4.32842712 8.67157288,5 9.5,5 L14.5,5 C15.3284271,5 16,4.32842712 16,3.5 L16,3 L18,3 C19.1045695,3 20,3.8954305 20,5 L20,21 C20,22.1045695 19.1045695,23 18,23 L6,23 C4.8954305,23 4,22.1045695 4,21 L4,5 C4,3.8954305 4.8954305,3 6,3 L8,3 Z",
                        fill: "#000000",
                        opacity: "0.3"
                      }
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        d:
                          "M11,2 C11,1.44771525 11.4477153,1 12,1 C12.5522847,1 13,1.44771525 13,2 L14.5,2 C14.7761424,2 15,2.22385763 15,2.5 L15,3.5 C15,3.77614237 14.7761424,4 14.5,4 L9.5,4 C9.22385763,4 9,3.77614237 9,3.5 L9,2.5 C9,2.22385763 9.22385763,2 9.5,2 L11,2 Z",
                        fill: "#000000"
                      }
                    }),
                    _vm._v(" "),
                    _c("rect", {
                      attrs: {
                        fill: "#000000",
                        opacity: "0.3",
                        x: "7",
                        y: "10",
                        width: "5",
                        height: "2",
                        rx: "1"
                      }
                    }),
                    _vm._v(" "),
                    _c("rect", {
                      attrs: {
                        fill: "#000000",
                        opacity: "0.3",
                        x: "7",
                        y: "14",
                        width: "9",
                        height: "2",
                        rx: "1"
                      }
                    })
                  ]
                )
              ]
            )
          ])
        ])
      : _vm.type == "marketplace-package"
      ? _c("span", { staticClass: "symbol-label" }, [
          _c("span", { staticClass: "svg-icon svg-icon-primary svg-icon-2x" }, [
            _c(
              "svg",
              {
                attrs: {
                  xmlns: "http://www.w3.org/2000/svg",
                  "xmlns:xlink": "http://www.w3.org/1999/xlink",
                  width: "24px",
                  height: "24px",
                  viewBox: "0 0 24 24",
                  version: "1.1"
                }
              },
              [
                _c(
                  "g",
                  {
                    attrs: {
                      stroke: "none",
                      "stroke-width": "1",
                      fill: "none",
                      "fill-rule": "evenodd"
                    }
                  },
                  [
                    _c("rect", {
                      attrs: { x: "0", y: "0", width: "24", height: "24" }
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        d:
                          "M10,4 L21,4 C21.5522847,4 22,4.44771525 22,5 L22,7 C22,7.55228475 21.5522847,8 21,8 L10,8 C9.44771525,8 9,7.55228475 9,7 L9,5 C9,4.44771525 9.44771525,4 10,4 Z M10,10 L21,10 C21.5522847,10 22,10.4477153 22,11 L22,13 C22,13.5522847 21.5522847,14 21,14 L10,14 C9.44771525,14 9,13.5522847 9,13 L9,11 C9,10.4477153 9.44771525,10 10,10 Z M10,16 L21,16 C21.5522847,16 22,16.4477153 22,17 L22,19 C22,19.5522847 21.5522847,20 21,20 L10,20 C9.44771525,20 9,19.5522847 9,19 L9,17 C9,16.4477153 9.44771525,16 10,16 Z",
                        fill: "#000000"
                      }
                    }),
                    _vm._v(" "),
                    _c("rect", {
                      attrs: {
                        fill: "#000000",
                        opacity: "0.3",
                        x: "2",
                        y: "4",
                        width: "5",
                        height: "16",
                        rx: "1"
                      }
                    })
                  ]
                )
              ]
            )
          ])
        ])
      : _vm.type == "close"
      ? _c("span", { staticClass: "symbol-label" }, [
          _c("span", { staticClass: "svg-icon svg-icon-primary svg-icon-2x" }, [
            _c(
              "svg",
              {
                attrs: {
                  xmlns: "http://www.w3.org/2000/svg",
                  "xmlns:xlink": "http://www.w3.org/1999/xlink",
                  width: "24px",
                  height: "24px",
                  viewBox: "0 0 24 24",
                  version: "1.1"
                }
              },
              [
                _c(
                  "g",
                  {
                    attrs: {
                      stroke: "none",
                      "stroke-width": "1",
                      fill: "none",
                      "fill-rule": "evenodd"
                    }
                  },
                  [
                    _c(
                      "g",
                      {
                        attrs: {
                          transform:
                            "translate(12.000000, 12.000000) rotate(-45.000000) translate(-12.000000, -12.000000) translate(4.000000, 4.000000)",
                          fill: "#000000"
                        }
                      },
                      [
                        _c("rect", {
                          attrs: {
                            x: "0",
                            y: "7",
                            width: "16",
                            height: "2",
                            rx: "1"
                          }
                        }),
                        _vm._v(" "),
                        _c("rect", {
                          attrs: {
                            opacity: "0.3",
                            transform:
                              "translate(8.000000, 8.000000) rotate(-270.000000) translate(-8.000000, -8.000000) ",
                            x: "0",
                            y: "7",
                            width: "16",
                            height: "2",
                            rx: "1"
                          }
                        })
                      ]
                    )
                  ]
                )
              ]
            )
          ])
        ])
      : _vm.type == "load"
      ? _c("span", { staticClass: "symbol-label" }, [
          _c("span", { staticClass: "svg-icon svg-icon-primary svg-icon-2x" }, [
            _c(
              "svg",
              {
                attrs: {
                  xmlns: "http://www.w3.org/2000/svg",
                  "xmlns:xlink": "http://www.w3.org/1999/xlink",
                  width: "24px",
                  height: "24px",
                  viewBox: "0 0 24 24",
                  version: "1.1"
                }
              },
              [
                _c(
                  "g",
                  {
                    attrs: {
                      stroke: "none",
                      "stroke-width": "1",
                      fill: "none",
                      "fill-rule": "evenodd"
                    }
                  },
                  [
                    _c("g", [
                      _c("polygon", {
                        attrs: { points: "0 0 24 0 24 24 0 24" }
                      })
                    ]),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        d:
                          "M12,4 L12,6 C8.6862915,6 6,8.6862915 6,12 C6,15.3137085 8.6862915,18 12,18 C15.3137085,18 18,15.3137085 18,12 C18,10.9603196 17.7360885,9.96126435 17.2402578,9.07513926 L18.9856052,8.09853149 C19.6473536,9.28117708 20,10.6161442 20,12 C20,16.418278 16.418278,20 12,20 C7.581722,20 4,16.418278 4,12 C4,7.581722 7.581722,4 12,4 Z",
                        fill: "#000000",
                        "fill-rule": "nonzero",
                        opacity: "0.3",
                        transform:
                          "translate(12.000000, 12.000000) scale(-1, 1) translate(-12.000000, -12.000000) "
                      }
                    })
                  ]
                )
              ]
            )
          ])
        ])
      : _vm.type == "montage"
      ? _c("span", { staticClass: "symbol-label" }, [
          _c("span", { staticClass: "svg-icon svg-icon-primary svg-icon-2x" }, [
            _c(
              "svg",
              {
                attrs: {
                  xmlns: "http://www.w3.org/2000/svg",
                  "xmlns:xlink": "http://www.w3.org/1999/xlink",
                  width: "24px",
                  height: "24px",
                  viewBox: "0 0 24 24",
                  version: "1.1"
                }
              },
              [
                _c(
                  "g",
                  {
                    attrs: {
                      stroke: "none",
                      "stroke-width": "1",
                      fill: "none",
                      "fill-rule": "evenodd"
                    }
                  },
                  [
                    _c("rect", {
                      attrs: { x: "0", y: "0", width: "24", height: "24" }
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        d:
                          "M1,12 L1,14 L6,14 L6,12 L1,12 Z M0,10 L20,10 C20.5522847,10 21,10.4477153 21,11 L21,15 C21,15.5522847 20.5522847,16 20,16 L0,16 C-0.55228475,16 -1,15.5522847 -1,15 L-1,11 C-1,10.4477153 -0.55228475,10 0,10 Z",
                        fill: "#000000",
                        "fill-rule": "nonzero",
                        transform:
                          "translate(10.000000, 13.000000) rotate(-225.000000) translate(-10.000000, -13.000000) "
                      }
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        d:
                          "M17.5,12 L18.5,12 C18.7761424,12 19,12.2238576 19,12.5 L19,13.5 C19,13.7761424 18.7761424,14 18.5,14 L17.5,14 C17.2238576,14 17,13.7761424 17,13.5 L17,12.5 C17,12.2238576 17.2238576,12 17.5,12 Z M20.5,9 L21.5,9 C21.7761424,9 22,9.22385763 22,9.5 L22,10.5 C22,10.7761424 21.7761424,11 21.5,11 L20.5,11 C20.2238576,11 20,10.7761424 20,10.5 L20,9.5 C20,9.22385763 20.2238576,9 20.5,9 Z M21.5,13 L22.5,13 C22.7761424,13 23,13.2238576 23,13.5 L23,14.5 C23,14.7761424 22.7761424,15 22.5,15 L21.5,15 C21.2238576,15 21,14.7761424 21,14.5 L21,13.5 C21,13.2238576 21.2238576,13 21.5,13 Z",
                        fill: "#000000",
                        opacity: "0.3"
                      }
                    })
                  ]
                )
              ]
            )
          ])
        ])
      : _vm.type == "costs"
      ? _c("span", { staticClass: "symbol-label" }, [
          _c("span", { staticClass: "svg-icon svg-icon-primary svg-icon-2x" }, [
            _c(
              "svg",
              {
                attrs: {
                  xmlns: "http://www.w3.org/2000/svg",
                  "xmlns:xlink": "http://www.w3.org/1999/xlink",
                  width: "24px",
                  height: "24px",
                  viewBox: "0 0 24 24",
                  version: "1.1"
                }
              },
              [
                _c(
                  "g",
                  {
                    attrs: {
                      stroke: "none",
                      "stroke-width": "1",
                      fill: "none",
                      "fill-rule": "evenodd"
                    }
                  },
                  [
                    _c("rect", {
                      attrs: { x: "0", y: "0", width: "24", height: "24" }
                    }),
                    _vm._v(" "),
                    _c("rect", {
                      attrs: {
                        fill: "#000000",
                        opacity: "0.3",
                        x: "7",
                        y: "4",
                        width: "3",
                        height: "13",
                        rx: "1.5"
                      }
                    }),
                    _vm._v(" "),
                    _c("rect", {
                      attrs: {
                        fill: "#000000",
                        opacity: "0.3",
                        x: "12",
                        y: "9",
                        width: "3",
                        height: "8",
                        rx: "1.5"
                      }
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        d:
                          "M5,19 L20,19 C20.5522847,19 21,19.4477153 21,20 C21,20.5522847 20.5522847,21 20,21 L4,21 C3.44771525,21 3,20.5522847 3,20 L3,4 C3,3.44771525 3.44771525,3 4,3 C4.55228475,3 5,3.44771525 5,4 L5,19 Z",
                        fill: "#000000",
                        "fill-rule": "nonzero"
                      }
                    }),
                    _vm._v(" "),
                    _c("rect", {
                      attrs: {
                        fill: "#000000",
                        opacity: "0.3",
                        x: "17",
                        y: "11",
                        width: "3",
                        height: "6",
                        rx: "1.5"
                      }
                    })
                  ]
                )
              ]
            )
          ])
        ])
      : _vm.type == "minus"
      ? _c("span", { staticClass: "symbol-label" }, [
          _c("span", { staticClass: "svg-icon svg-icon-primary svg-icon-2x" }, [
            _c(
              "svg",
              {
                attrs: {
                  xmlns: "http://www.w3.org/2000/svg",
                  "xmlns:xlink": "http://www.w3.org/1999/xlink",
                  width: "24px",
                  height: "24px",
                  viewBox: "0 0 24 24",
                  version: "1.1"
                }
              },
              [
                _c(
                  "g",
                  {
                    attrs: {
                      stroke: "none",
                      "stroke-width": "1",
                      fill: "none",
                      "fill-rule": "evenodd"
                    }
                  },
                  [
                    _c("rect", {
                      attrs: {
                        fill: "#000000",
                        x: "4",
                        y: "11",
                        width: "16",
                        height: "2",
                        rx: "1"
                      }
                    })
                  ]
                )
              ]
            )
          ])
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }